import { render } from "./referral-reward.vue?vue&type=template&id=622a6986&scoped=true"
import script from "./referral-reward.vue?vue&type=script&lang=js"
export * from "./referral-reward.vue?vue&type=script&lang=js"

import "./referral-reward.vue?vue&type=style&index=0&id=622a6986&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622a6986"]])

export default __exports__